"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Header;
var _react = _interopRequireDefault(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _useTranslation = _interopRequireDefault(require("../../hooks/useTranslation"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function Header() {
  var t = (0, _useTranslation.default)();
  return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 8,
      bottom: 8
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    size: 2,
    weight: 3,
    text: t('main_title')
  }));
}